export default __webpack_public_path__ + "static/media/mute.f7d4c39e.png";